/**
 * Utility functions for formatting distances.
 */

/**
 * Formats a distance in meters to a human-readable string.
 * For distances >= 1000m, displays in km with 1 decimal place.
 * For distances < 1000m, displays in meters (rounded).
 *
 * @param distanceMeters - The distance in meters, can be null or undefined
 * @returns Formatted distance string (e.g., "50 m", "1.5 km") or "-" if null/undefined
 */
export const formatDistance = (distanceMeters: number | null | undefined): string => {
  if (distanceMeters == null) return "-";
  if (distanceMeters >= 1000) {
    return `${(distanceMeters / 1000).toFixed(1)} km`;
  }
  return `${Math.round(distanceMeters)} m`;
};
